import React, {Component} from 'react';
import {
  fetchConstructionDetailForReport
} from 'actions/ConstructionActions'

const ConstructionInfo = ({name, year, assignTo}) => (
  <table className="construction-info">
    <thead>
      <tr>
        <th colSpan={6}>
          工程資訊
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          年份:
        </td>
        <td>
          {year}
        </td>
        <td>
          工程名稱:
        </td>
        <td>
          {name}
        </td>
        <td>
          執行公司:
        </td>
        <td>
          {assignTo}
        </td>
      </tr>
    </tbody>
  </table>
)

const TotalCost = ({labourTotal, paymentTotal}) => (
  <table className="total-cost-info">
    <thead>
      <tr>
        <th>
          勞動力支出
        </th>
        <th>
          其他支出
        </th>
        <th>
          總支出
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          ${labourTotal}
        </td>
        <td>
          ${paymentTotal}
        </td>
        <td>
          ${labourTotal + paymentTotal}
        </td>
      </tr>
    </tbody>
  </table>
)

const CostInfo = ({header, costDetail}) => {
  let subTotal = 0;
  return (
    <table className="cost-info">
      <thead>
        <tr>
          <th colSpan={2}>
            {header}
          </th>
        </tr>
        <tr>
          <th className="sub-header">
            類別
          </th>
          <th className="sub-header">
            花費
          </th>
        </tr>
      </thead>
      <tbody>
        {costDetail.map(({notes, amount}) => {
          subTotal += amount;
          return (
            <tr>
              <td>
                {notes}
              </td>
              <td>
                ${amount}
              </td>
            </tr>
          )
        })}
        <tr>
          <td className="sub-total">
            小計
          </td>
          <td>
            ${subTotal}
          </td>
        </tr>
      </tbody>
    </table>
  )
}

const ProfitInfo = ({totalPrice, totalCost}) => (
  <table className="profit-info">
    <thead>
      <tr>
        <th>
          總價
        </th>
        <th>
          利潤
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          ${totalPrice}
        </td>
        <td>
          {totalCost > totalPrice && "- "}${Math.abs(totalPrice - totalCost)}
        </td>
      </tr>
    </tbody>
  </table>
)

class Cost extends Component {
  state = {
    loading: true,
    error: false
  }

  componentDidMount() {
    let {cid} = this.props.params;
    fetchConstructionDetailForReport(cid)
      .then((response) => {
        if (response.data.name.length === 0) throw new Error("error")
        this.setState({
          loading: false,
          ...response.data
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: true
        })
      }) 
  }

  render() {
    let {name, year, assignTo, labour=[], payment=[], totalPrice} = this.state;
    const labourTotal = labour.reduce((s, { amount = 0}) => s + amount, 0);
    const paymentTotal = payment.reduce((s, { amount = 0}) => s + amount, 0);

    return (!this.state.loading && 
      (
        this.state.error?
        <div className="cost-report">
          <h4>
            報告不存在
          </h4>
        </div>
        :
        <div className="cost-report">
          <h4>工程支出報告</h4>
          <ConstructionInfo year={year} name={name} assignTo={assignTo} />
          {labour.length > 0 && <CostInfo header="勞動力支出" costDetail={labour}/>}
          {payment.length > 0 && <CostInfo header="其他支出" costDetail={payment}/>}
          <TotalCost labourTotal={labourTotal} paymentTotal={paymentTotal} />
          <ProfitInfo totalPrice={totalPrice} totalCost={labourTotal + paymentTotal} />
        </div>
      )      
    )
  }
}

export default Cost;


// WEBPACK FOOTER //
// ./src/components/Report/Cost.js